import { useState } from 'react';
import { bindReferralCode } from '../api';
import {
    REFERRAL_CODE_LENGTH,
    sanitizeReferralCodeInput,
} from '../utils/referral';
import { track, trackErrorCode } from '../utils/analytics';
import './BindReferralForm.scss';

export default function BindReferralForm({ onSuccess, ownReferralCode }) {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const trimmed = sanitizeReferralCodeInput(code);
        if (!trimmed) {
            setError('Введите реферальный код');
            return;
        }

        if (trimmed.length !== REFERRAL_CODE_LENGTH) {
            setError(`Код должен содержать ${REFERRAL_CODE_LENGTH} символов`);
            return;
        }

        if (ownReferralCode && trimmed === sanitizeReferralCodeInput(ownReferralCode)) {
            setError('Нельзя указать свой реферальный код');
            return;
        }

        setSubmitting(true);
        setError('');
        try {
            const result = await bindReferralCode(trimmed);
            track('referral_bound_success');
            onSuccess(result.referred_by);
        } catch (err) {
            trackErrorCode('referral_bound_error', err.message);
            setError(err.message || 'Не удалось привязать код');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form className="bind-referral-form" onSubmit={handleSubmit}>
            <div className="bind-referral-form__row">
                <input
                    className={`bind-referral-form__input${error ? ' bind-referral-form__input--error' : ''}`}
                    type="text"
                    value={code}
                    onChange={(e) => {
                        setCode(sanitizeReferralCodeInput(e.target.value));
                        if (error) setError('');
                    }}
                    placeholder="A1B2C3D4"
                    disabled={submitting}
                    autoComplete="off"
                    spellCheck={false}
                    maxLength={REFERRAL_CODE_LENGTH}
                    aria-label="Реферальный код друга"
                />
                <button
                    type="submit"
                    className="btn btn--outline btn--sm"
                    disabled={submitting || code.length !== REFERRAL_CODE_LENGTH}
                >
                    {submitting ? 'Привязываем...' : 'Привязать'}
                </button>
            </div>
            {error && <p className="bind-referral-form__error">{error}</p>}
        </form>
    );
}
